// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.MovePatientFileRequest */
/* istanbul ignore next */
@GandalfModel
export class MovePatientFileRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Folder is required' } })
	@GandalfValidator({ sizeString: { message: 'Folder must be between 1 and 50 characters', minLength: 1, maxLength: 50 } })
	@GandalfProperty({ designType: String, isRequired: true })
	folderId!: string;

	@GandalfValidator({ notNull: { message: 'Patient File is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientFileId!: number;

}
